import React from "react";
import {
    Button,
    convertInputFormToObject,
    SelectField
} from "../../../../Components/Inputs";
import {GridCell, gridConstants, GridContainer} from "../../../../Components/Grid";
import {LinkButton} from "../../../../Components/Link";
import {locations} from "../../../../Utilities/Location";
import {isOwnLoanFormValid} from "./ownQueueUtility";
import {isRmtcAdmin} from "../../../../Utilities/LocalStorage/storageUtilities";
import type {ListItem} from "../../../../Utilities/Types/listUtilities";

interface OwnQueueFormProps {
    ownLoanForm: Record<string, any>;
    handleAssignOwnQueueItems: (data: Record<string, unknown>) => void;
    setWarnings: (warnings: string[]) => void;
    shippingLocations: ListItem[];
}

export const OwnQueueForm = ({
                                 ownLoanForm,
                                 handleAssignOwnQueueItems,
                                 setWarnings,
                                 shippingLocations,
                             }: OwnQueueFormProps) => {

    const handleClickSubmit = () => {

        if (!isRmtcAdmin() && !isOwnLoanFormValid(ownLoanForm)) {
            setWarnings(["Missing required items.  Please review your responses and try submitting again.",]);
            return;
        }

        const loanModel = convertInputFormToObject(ownLoanForm);
        handleAssignOwnQueueItems(loanModel);
    }

    return <>
        <GridContainer hasMarginX>
            <GridCell medium_columns={gridConstants.column.SIX} large_columns={gridConstants.column.SIX}
                      medium_offset={gridConstants.column.SIX} large_offset={gridConstants.column.SIX}>
                <SelectField
                    {...ownLoanForm.shippingLocationId}
                    defaultOption={`Select Shipping Location`}
                    medium_columns={gridConstants.column.SIX}
                    large_columns={gridConstants.column.SIX}
                    label={`Location`}
                    helpText={`<p><b>Please ship to your school address if possible to reduce shipping costs.</b></p>`}
                    options={shippingLocations}
                />
            </GridCell>

            <GridCell medium_columns={gridConstants.column.SIX} large_columns={gridConstants.column.SIX}
                      medium_offset={gridConstants.column.SIX} large_offset={gridConstants.column.SIX}>
                <LinkButton {...locations.SHIPPING_LOCATION_ADD.link} isExpanded/>
            </GridCell>

            <GridCell medium_columns={gridConstants.column.SIX} large_columns={gridConstants.column.SIX}
                      medium_offset={gridConstants.column.SIX} large_offset={gridConstants.column.SIX}
                      className="text-right">
                <Button
                    isPrimary
                    isCollapsed
                    type="button"
                    label={`Submit`}
                    name={`btnSubmit`}
                    onClick={handleClickSubmit}
                />
            </GridCell>       
     </GridContainer>
        <br/>
        <br/>
    </>;
};
